import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'components/Modal';
import RichTextProcessor from 'utils/RichTextProcessor';

import Chart from './Chart';

const SizeChartModal = ({ isOpen, closeModal, modalSettings, sizeChart }) => {
  const SupportingCopy1Components = new RichTextProcessor(
    sizeChart.supportingCopy1
  ).getReactComponents();

  const SupportingCopy2Components = new RichTextProcessor(
    sizeChart.supportingCopy2
  ).getReactComponents();

  return (
    <Modal
      isOpen={isOpen}
      className="PdpSizeChart__modal"
      onRequestClose={closeModal}
      {...modalSettings}
    >
      <div className="PdpSizeChart__modal-body flex flex-col">
        <h2 className="m-0 mb-3 p-0 text-2xl font-bold leading-tight tracking-wide md:text-[28px] md:leading-[1.36] lg:text-[32px] lg:leading-[1.31]">
          {sizeChart.title}
        </h2>

        <div className="lg:w-3/4">{SupportingCopy1Components}</div>

        {map(sizeChart.sizeChartTables, (table, i) => (
          <Chart key={`table-${i}`} data={table.data} heading={table.heading} />
        ))}
      </div>
      {SupportingCopy2Components}
    </Modal>
  );
};

SizeChartModal.propTypes = {
  isOpen: PropTypes.bool,
  modalSettings: PropTypes.shape({}),
  closeModal: PropTypes.func.isRequired,
  sizeChart: PropTypes.shape({
    title: PropTypes.string,
    supportingCopy1: PropTypes.object,
    supportingCopy2: PropTypes.object,
    sizeChartTables: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired }))
        ),
      })
    ),
  }).isRequired,
};

SizeChartModal.defaultProps = {
  isOpen: false,
  modalSettings: {},
};

export default SizeChartModal;
